angular.module('jv.CandDetails.findDefaultTemplate', ['jv.Common.Filters'])
    .factory('findDefaultTemplate', [function() {
        return function findDefaultTemplate(templates) {
            var rejectObject = {
                template: '',
                subject: '',
                message: ''
            };

            angular.forEach(templates, function(template) {
                if(template['default']) {
                    rejectObject = {
                        template: template.EId,
                        subject: template.subject || '',
                        message: template.body || ''
                    };
                }
            });

            return rejectObject;
        }
    }]);
